import React from 'react'
import { reactular } from '@vendhq/reactular'

interface Props {
  name: string
}

export const SalesPersonInfo: React.FC<Props> = ({ name }) => {
  return (
    <div className="vd-mt4 vd-mb4">
      <strong>Sold by</strong>
      <span style={{ wordBreak: 'break-word' }}>{` ${name}`}</span>
    </div>
  )
}

export const SalesPersonInfoComponent = reactular(SalesPersonInfo, ['name'])
